import React from 'react';
import Icon, { Props } from './icon';

export const TvLine: React.FC<Props> = (props: Props) => {
  return (
    <Icon {...props} viewBox="0 0 40 40">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6906 3.80251C11.1219 3.26343 11.9085 3.17603 12.4476 3.60729L20 9.64926L27.5525 3.60729C28.0916 3.17603 28.8782 3.26343 29.3095 3.80251C29.7407 4.34158 29.6533 5.1282 29.1142 5.55946L21.4802 11.6667H34.9399C35.8936 11.6667 36.6667 12.386 36.6667 13.2734V33.3932C36.6667 34.2806 35.8936 35 34.9399 35H5.06005C4.10641 35 3.33333 34.2806 3.33333 33.3932V13.2734C3.33333 12.386 4.10641 11.6667 5.06006 11.6667H18.5198L10.8858 5.55946C10.3468 5.1282 10.2594 4.34158 10.6906 3.80251ZM5.88588 32.6247V14.0419H34.1141V32.6247H5.88588Z"
      />
    </Icon>
  );
};

export default React.memo(TvLine);
